/* eslint-disable max-statements */
import AddGoogleEventComponent from '../../components/calendar/create_link';
import AddGoogleMeetingComponent from '../../components/calendar/create_meeting';
import CalendarLinksComponent from '../../components/calendar/calendar_links';
import CardWrapper from '../../components/wrapper/card';
import { CustomerObject } from '../../params/redux/customer';
import EditNotificationsComponent from '../../components/calendar/edit_notifications';
import EventFormComponent from '../../components/calendar/calendar_form_builder';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import MyEventsComponent from '../../components/calendar/my_events';
import { Overlay } from '../../components/prospecting';
import OverviewComponent from '../../components/calendar/overview';
import SetAvailabilityComponent from '../../components/calendar/set_availability';
import { settingSelectedCustomer } from '../../redux/slices/customer';
import { useParams } from 'react-router';
import { a11yProps, CustomTabPanel } from '../deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, CircularProgress, Tab, Tabs, Typography } from '@mui/material';
import { fetchAllTimeZonesThunk, fetchCalendarReminderThunk, fetchDaysThunk, fetchGoogleEventsThunk, fetchUserTimeZoneThunk, saveDaysThunk } from '../../redux/thunks/calendar';
import { fetchCustomerIntegrationsThunk, fetchIntegrationsThunk } from '../../redux/thunks/integration';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const CalendarPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();
  const [value, setValue] = useState(0);
  const { addEvent, addMeeting, loaders: googleLoaders, flags, slots } = useSelector((state: RootState) => state.calendar);
  const { loaders } = useSelector((state: RootState) => state.integration);
  const { currentUser } = useSelector((state: RootState) => state.app);
  const { selectedCustomer } = useSelector((state: RootState) => state.customer);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    console.log(event);
    setValue(newValue);
  };

  useEffect(() => {
    const fetchIntegraions = async () => {
      try {
        if ((currentUser?.role === 'organizationAdmin' || currentUser?.role === 'organizationOwner' || currentUser?.role === 'companyManager') && (location.pathname.includes('/app/client/') || !location.pathname.includes('/app/calendar'))) {
          const response = await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
          if ((response as CustomerObject[])?.length > 0) {
            const data: CustomerObject[] = response as CustomerObject[];
            dispatch(settingSelectedCustomer(data[0]));
            await dispatch(fetchCustomerIntegrationsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
          } else {
            dispatch(settingSelectedCustomer(null));
          }
        } else {
          await dispatch(fetchIntegrationsThunk()).unwrap();
        }
      } catch (e) {
        dispatch(settingSelectedCustomer(null));
      }
    };
    fetchIntegraions();
  }, [dispatch]);

  // useEffect(() => {
  //   const isCalendarConnected = integrations.includes('calendar');
  //   const isMeetConnected = integrations.includes('meet');
  //   if (!isCalendarConnected && !isMeetConnected) {
  //     setIsConnected(false);
  //   } else {
  //     setIsConnected(true);
  //   }
  // }, [integrations]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        let user_id = 0;
        if (id && currentUser?.role !== 'client') {
          user_id = selectedCustomer?.id || 0;
        } else {
          user_id = currentUser?.id as number;
        }

        if (flags.isSettingAvailability) {
          if (slots.selectedTab === 0) {
            await dispatch(saveDaysThunk(user_id)).unwrap();
            await dispatch(fetchDaysThunk(user_id)).unwrap();
          }
          await Promise.all([
            dispatch(fetchAllTimeZonesThunk()).unwrap(),
            dispatch(fetchUserTimeZoneThunk(user_id)).unwrap()
          ]);
        } else if (user_id && user_id !== 0) {
          await dispatch(fetchCalendarReminderThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
          await dispatch(fetchGoogleEventsThunk(user_id)).unwrap();
        }
      } catch (e) {
        //
      }
    };
    // if (isConnected) {
      fetchEvents();
    // }
  }, [value, flags.isSettingAvailability]);

  if (loaders.isLoading || googleLoaders.isLoading) {
    return <Overlay display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap="20px">
      <CircularProgress />
      <Typography variant="body2">Please Wait...</Typography>
    </Overlay>;
  }
  if (flags.isSettingAvailability) {
    return <SetAvailabilityComponent />;
  }
  if (flags.isEditNotifications) {
    return <EditNotificationsComponent />;
  }
  if (flags.isEditEventsForm) {
    return <EventFormComponent />;
  }
  // if (!isConnected && !location.pathname.includes('/app/client/')) {
  //   return (<Box padding="15px" minHeight="80vh" overflow="auto">
  //     <CardWrapper>
  //       <Box display="flex" flexDirection="column" alignItems="center" gap="20px" justifyContent="center" height="84vh">
  //         <Typography variant="h3" align="center" display="flex" alignItems="center" gap="10px" fontWeight="bold" color="textSecondary">
  // Integrate <img src={ImageClass.googleFullNameLogo} style={{
  //           marginTop: '5px'
  //         }} alt="Google Logo" height="35px" /> calendar to sync and view all meetings</Typography>
  //         <Button variant="contained" onClick={() => navigate('/app/integrations')}>Navigate to Integrations</Button>
  //       </Box>
  //     </CardWrapper>
  //   </Box>);
  // } else
  if (addEvent && !addMeeting) {
    return <AddGoogleEventComponent />;
  } else if (!addEvent && addMeeting) {
    return <AddGoogleMeetingComponent />;
  }
  return (
    <Box minHeight="80vh" overflow="auto">
      <CardWrapper>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="calendar details tabs"
        >
          <Tab
            label="Overview"
            {...a11yProps(0)}
          />
          <Tab
            label="My events"
            {...a11yProps(1)}
          />
          <Tab
            label="Calendar links"
            {...a11yProps(2)}
          />
        </Tabs>

        <CustomTabPanel value={value} index={0}>
          <OverviewComponent />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <MyEventsComponent />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <CalendarLinksComponent />
        </CustomTabPanel>
      </CardWrapper>
    </Box>
  );
};
export default CalendarPage;